import React from 'react';
import { useSelector } from 'react-redux';

import { Altitude as AltitudeUI } from '@/components/ui/dashboard/Monitor';

const Altitude = ({ data: robotId }) => {
  const globalPosition = useSelector((state) => state.telemetry[robotId]?.globalPosition);

  return <AltitudeUI relAltitude={globalPosition?.ralt ?? 0} />;
};

export default Altitude;
